import { meyersReset, rootStyles, typographyStyles } from './css';

const styles = { meyersReset, rootStyles, typographyStyles };

export default styles;
